import { PDFOptions } from 'puppeteer-core';
import BwipJs from 'bwip-js';
import { IGerarPDFAilos } from './types';
import maskFormat from '@/utils/maskFormat';
import { compileHbs } from '@/utils/compileHbs';
import { getPathTemplates } from '@/utils/getPathTemplates';
import { api } from '@/services/api';
import { decompress } from '@/utils/zip';

export async function gerarPDF({ dados }: IGerarPDFAilos) {
  try {
    const { generatePDF, dadosPDF } = dados;

    if (!dadosPDF.pagador.cpfcnpj) {
      throw new Error('CPF/CNPJ do pagador não informado!');
    }

    const codigoBarra = await BwipJs.toBuffer({
      bcid: 'interleaved2of5',
      text: dadosPDF.boleto.codigoBarra,
      height: 20,
    });

    dadosPDF.beneficiario.dadosBancario.agencia =
      dadosPDF.beneficiario.dadosBancario.agencia.padStart(4, '0');
    dadosPDF.beneficiario.dadosBancario.conta =
      dadosPDF.beneficiario.dadosBancario.conta.padStart(7, '0');

    dadosPDF.boleto.linhaDigitavel = maskFormat.codigoBarra(dadosPDF.boleto.linhaDigitavel);
    dadosPDF.boleto.codigoBarraImage = codigoBarra.toString('base64');
    dadosPDF.beneficiario.cnpj = maskFormat.retornaCpfCnpjFormatado(
      dadosPDF.beneficiario.cnpj,
    );
    dadosPDF.beneficiario.endereco.cep = maskFormat.retornaCEPFormatado(
      dadosPDF.beneficiario.endereco.cep,
    );
    dadosPDF.pagador.endereco.cep = maskFormat.retornaCEPFormatado(
      dadosPDF.pagador.endereco.cep,
    );
    dadosPDF.pagador.cpfcnpj = maskFormat.retornaCpfCnpjFormatado(dadosPDF.pagador.cpfcnpj);

    dadosPDF.boleto.valorAcrescimo = maskFormat.numberToReal(
      dadosPDF.boleto.valorAcrescimo,
    );
    dadosPDF.boleto.valorCobrado = maskFormat.numberToReal(
      dadosPDF.boleto.valorCobrado,
    );
    dadosPDF.boleto.valorDescontoAbatimento = maskFormat.numberToReal(
      dadosPDF.boleto.valorDescontoAbatimento,
    );
    const valorDocumento = Number(dadosPDF.boleto.valorDocumento);
    dadosPDF.boleto.valorDocumento = maskFormat.numberToReal(
      dadosPDF.boleto.valorDocumento,
    );
    dadosPDF.boleto.valorMulta = maskFormat.numberToReal(dadosPDF.boleto.valorMulta);
    dadosPDF.boleto.valorOutrasDeducoes = maskFormat.numberToReal(
      dadosPDF.boleto.valorOutrasDeducoes,
    );

    if (dadosPDF.boleto.quantidade) {
      dadosPDF.boleto.quantidade = maskFormat.numberToReal(dadosPDF.boleto.quantidade);
    }

    const jurosMes = dadosPDF.beneficiario.dadosBancario.juros;
    const jurosDia = (jurosMes / 100 / 30) * valorDocumento;
    if (jurosDia > 0) {
      dadosPDF.boleto.instrucao1 = `COBRAR JUROS DE R$${maskFormat.numberToReal(jurosDia)} AO DIA, APÓS O VENCIMENTO`;
    }

    const descontoVencimento = dadosPDF.boleto.desconto > 0 
      ? dadosPDF.boleto.desconto 
      : dadosPDF.beneficiario.dadosBancario.desconto > 0 
        ? dadosPDF.beneficiario.dadosBancario.desconto 
        : 0;
    if (descontoVencimento > 0) {
      dadosPDF.boleto.instrucao2 = `ATÉ O VENCIMENTO, CONCEDER DESCONTO DE ${descontoVencimento}%`;
    }

    const multaAtraso = dadosPDF.beneficiario.dadosBancario.multa || 0;
    if (multaAtraso > 0) {
      dadosPDF.boleto.instrucao3 = `MULTA DE ${multaAtraso}%`;
    }

    const protestoDias = dadosPDF.beneficiario.dadosBancario.protesto || 0;
    if (protestoDias > 0) {
      dadosPDF.boleto.instrucao4 = `PROTESTAR APÓS ${protestoDias} DIAS CORRIDOS DO VENCIMENTO`;
    }

    dadosPDF.boleto.valor = maskFormat.numberToReal(dadosPDF.boleto.valor);
    dadosPDF.pagador.isCnpj = dadosPDF.pagador.cpfcnpj.length > 14;
    const content = compileHbs(getPathTemplates('ailos-boleto.hbs'), dadosPDF);

    const config: PDFOptions = {
      displayHeaderFooter: false,
      path: './boleto.pdf',
      format: 'a4',
      printBackground: true,
    };

    let pdfBase64: string | null = null;

    if (generatePDF) {
      pdfBase64 = await generatePDF(content, config);
    } else {
      if (!api.defaults.baseURL) {
        throw new Error('BaseURL api not found');
      }

      const response = await api.post('/', { content, config });
      const buffer = Buffer.from(response.data.pdf);
      pdfBase64 = await decompress(buffer);
    }

    return {
      erro: false,
      dados: pdfBase64,
    };
  } catch (error) {
    console.log(error);
    if (error instanceof Error) {
      return {
        erro: true,
        dados: error.message,
      }
    }
    return {
      erro: true,
      dados: 'Falha ao gerar impressão do boleto',
    };
  }
}
